<template>
  <v-alert type="error" density="compact" class="app-error-state">
    <div class="app-error-state__body">
      <span class="app-error-state__message">{{ message }}</span>
      <div v-if="retryable || $slots.default" class="app-error-state__actions">
        <v-btn v-if="retryable" variant="outlined" color="error" size="small" @click="$emit('retry')">
          {{ retryLabel || $t("app.actions.retry") }}
        </v-btn>
        <slot />
      </div>
    </div>
  </v-alert>
</template>

<script>
/**
 * Error state standard (docs/design/ui-kit.md → Error state): încărcarea a eșuat. Mesajul spune ce nu a
 * mers, iar ieșirea este „Reîncearcă” (`retry`) sau alte acțiuni în slot („Resetează filtrele”, „Înapoi la
 * listă”). Părintele păstrează filtrele și datele deja încărcate; componenta nu le atinge.
 */
export default {
  name: "AppErrorState",
  props: {
    message: { type: String, required: true },
    retryable: { type: Boolean, default: true },
    retryLabel: { type: String, default: "" },
  },
  emits: ["retry"],
};
</script>

<style scoped>
.app-error-state__body {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--app-space-3);
}

.app-error-state__actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--app-space-2);
}
</style>
